module.exports = "img/flags/ZA.1ae8fe0.png";